[
  {
    "id": "ivig",
    "brandName": "Gammagard / Privigen / Octagam",
    "genericName": "Intravenous Immunoglobulin (IVIG)",
    "rxcui": null,
    "category": "Acute Rejection",
    "condition": "rejection-treatment",
    "manufacturer": "Various",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": "https://www.gammagard.com/primary-immunodeficiency/copay-support",
    "papProgramId": "takeda-gammagard-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "aranesp",
    "brandName": "Aranesp",
    "genericName": "Darbepoetin Alfa",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "Amgen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://www.amgensupportplus.com/",
    "papProgramId": "amgen-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "procrit",
    "brandName": "Procrit / Epogen",
    "genericName": "Epoetin Alfa",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "Janssen / Amgen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "injectafer",
    "brandName": "Injectafer",
    "genericName": "Ferric Carboxymaltose",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "American Regent",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://www.injectafer.com/ida/support-and-savings",
    "papProgramId": "dsi-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "feraheme",
    "brandName": "Feraheme",
    "genericName": "Ferumoxytol",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "AMAG",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://feraheme.com/download-resources/",
    "papProgramId": "amag-feraheme-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "venofer",
    "brandName": "Venofer",
    "genericName": "Iron Sucrose",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "American Regent",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://www.venofer.com/arassist",
    "papProgramId": "american-regent-venofer-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "mircera",
    "brandName": "Mircera",
    "genericName": "Methoxy Polyethylene Glycol-Epoetin Beta",
    "rxcui": null,
    "category": "Anemia",
    "condition": "anemia",
    "manufacturer": "Vifor Pharma",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.cslvifor.com/",
    "papProgramId": "vifor-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "amiodarone",
    "brandName": "Pacerone / Cordarone",
    "genericName": "Amiodarone",
    "rxcui": "703",
    "category": "Antiarrhythmic",
    "condition": "heart-rhythm",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "flecainide",
    "brandName": "Tambocor",
    "genericName": "Flecainide",
    "rxcui": null,
    "category": "Antiarrhythmic",
    "condition": "heart-rhythm",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "amoxicillin",
    "brandName": "Amoxil",
    "genericName": "Amoxicillin",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "azithromycin",
    "brandName": "Zithromax / Z-Pak",
    "genericName": "Azithromycin",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cephalexin",
    "brandName": "Keflex",
    "genericName": "Cephalexin",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "ciprofloxacin",
    "brandName": "Cipro",
    "genericName": "Ciprofloxacin",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "doxycycline",
    "brandName": "Vibramycin",
    "genericName": "Doxycycline",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "levofloxacin",
    "brandName": "Levaquin",
    "genericName": "Levofloxacin",
    "rxcui": null,
    "category": "Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "soliris",
    "brandName": "Soliris",
    "genericName": "Eculizumab",
    "rxcui": null,
    "category": "Antibody-Mediated Rejection",
    "condition": "rejection-treatment",
    "manufacturer": "Alexion",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://alexion.com/patient-support-services",
    "papProgramId": "alexion-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ultomiris",
    "brandName": "Ultomiris",
    "genericName": "Ravulizumab",
    "rxcui": null,
    "category": "Antibody-Mediated Rejection",
    "condition": "rejection-treatment",
    "manufacturer": "Alexion",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://alexion.com/patient-support-services",
    "papProgramId": "alexion-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "apixaban",
    "brandName": "Eliquis",
    "genericName": "Apixaban",
    "rxcui": null,
    "category": "Anticoagulant",
    "condition": "blood-clots",
    "manufacturer": "Bristol Myers Squibb",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": "https://www.bmspaf.org/",
    "papProgramId": "bms-pap",
    "copayUrl": "https://www.eliquis.bmscustomerconnect.com/savings",
    "copayProgramId": "eliquis-copay",
    "supportUrl": "https://www.bmscopay.com/",
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "clopidogrel",
    "brandName": "Plavix",
    "genericName": "Clopidogrel",
    "rxcui": null,
    "category": "Anticoagulant",
    "condition": "blood-clots",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "rivaroxaban",
    "brandName": "Xarelto",
    "genericName": "Rivaroxaban",
    "rxcui": null,
    "category": "Anticoagulant",
    "condition": "blood-clots",
    "manufacturer": "Janssen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.xarelto-us.com/xarelto-cost/",
    "copayProgramId": "xarelto-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "warfarin",
    "brandName": "Coumadin",
    "genericName": "Warfarin",
    "rxcui": null,
    "category": "Anticoagulant",
    "condition": "blood-clots",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "ondansetron",
    "brandName": "Zofran",
    "genericName": "Ondansetron",
    "rxcui": null,
    "category": "Antiemetic",
    "condition": "digestive",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "diflucan",
    "brandName": "Diflucan",
    "genericName": "Fluconazole",
    "rxcui": "4450",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Pfizer",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "pfizer-copay",
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cresemba",
    "brandName": "Cresemba",
    "genericName": "Isavuconazonium",
    "rxcui": "1656657",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Astellas",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.astellaspharmasupportsolutions.com/",
    "papProgramId": "astellas-pap",
    "copayUrl": "https://www.astellaspharmasupportsolutions.com/",
    "copayProgramId": "cresemba-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "sporanox",
    "brandName": "Sporanox",
    "genericName": "Itraconazole",
    "rxcui": "202826",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Janssen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "janssen-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "tolsura",
    "brandName": "Tolsura",
    "genericName": "Itraconazole (SUBA)",
    "rxcui": "2106643",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Mayne Pharma",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "nystatin",
    "brandName": "Bio-Statin / Nystop",
    "genericName": "Nystatin",
    "rxcui": "7597",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "noxafil",
    "brandName": "Noxafil",
    "genericName": "Posaconazole",
    "rxcui": "282077",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Merck",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.merckhelps.com/",
    "papProgramId": "merck-pap",
    "copayUrl": "https://www.merckhelps.com/",
    "copayProgramId": "merck-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "vfend",
    "brandName": "Vfend",
    "genericName": "Voriconazole",
    "rxcui": "121243",
    "category": "Anti-fungal",
    "condition": "infection",
    "manufacturer": "Pfizer",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "pfizer-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "cetirizine",
    "brandName": "Zyrtec",
    "genericName": "Cetirizine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "desloratadine",
    "brandName": "Clarinex",
    "genericName": "Desloratadine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "fexofenadine",
    "brandName": "Allegra",
    "genericName": "Fexofenadine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "hydroxyzine",
    "brandName": "Atarax / Vistaril",
    "genericName": "Hydroxyzine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "levocetirizine",
    "brandName": "Xyzal",
    "genericName": "Levocetirizine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "loratadine",
    "brandName": "Claritin",
    "genericName": "Loratadine",
    "rxcui": null,
    "category": "Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "aspirin",
    "brandName": "Ecotrin / Bayer",
    "genericName": "Aspirin",
    "rxcui": "1191",
    "category": "Antiplatelet",
    "condition": "blood-clots",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "quetiapine",
    "brandName": "Seroquel",
    "genericName": "Quetiapine",
    "rxcui": null,
    "category": "Antipsychotic",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "zovirax",
    "brandName": "Zovirax",
    "genericName": "Acyclovir",
    "rxcui": "281",
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cytovene",
    "brandName": "Cytovene",
    "genericName": "Ganciclovir",
    "rxcui": "4629",
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Genentech",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.genentech-access.com/patient.html",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.genentech-access.com/patient.html",
    "copayProgramId": "genentech-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "prevymis",
    "brandName": "Prevymis",
    "genericName": "Letermovir",
    "rxcui": "1943541",
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Merck",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.merckhelps.com/",
    "papProgramId": "merck-pap",
    "copayUrl": "https://www.merckhelps.com/",
    "copayProgramId": "prevymis-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "livtencity",
    "brandName": "Livtencity",
    "genericName": "Maribavir",
    "rxcui": null,
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Takeda",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.takeda.com/en-us/what-we-do/patient-services/",
    "papProgramId": "takeda-pap",
    "copayUrl": "https://www.takeda.com/en-us/what-we-do/patient-services/",
    "copayProgramId": "livtencity-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "valtrex",
    "brandName": "Valtrex",
    "genericName": "Valacyclovir",
    "rxcui": "10998",
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "valcyte",
    "brandName": "Valcyte",
    "genericName": "Valganciclovir",
    "rxcui": "284635",
    "category": "Anti-viral",
    "condition": "infection",
    "manufacturer": "Genentech",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.genentech-access.com/patient.html",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.genentech-access.com/patient.html",
    "copayProgramId": "genentech-copay",
    "supportUrl": "https://www.gene.com/patients/patient-support-services",
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "benralizumab",
    "brandName": "Fasenra",
    "genericName": "Benralizumab",
    "rxcui": null,
    "category": "Asthma Biologic",
    "condition": "asthma-copd",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": "astrazeneca-pap",
    "copayUrl": "https://www.fasenra.com/savings-support",
    "copayProgramId": "fasenra-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "mepolizumab",
    "brandName": "Nucala",
    "genericName": "Mepolizumab",
    "rxcui": null,
    "category": "Asthma Biologic",
    "condition": "asthma-copd",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": "https://www.nucala.com/support-resources/patient-support-program/",
    "copayProgramId": "nucala-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "omalizumab",
    "brandName": "Xolair",
    "genericName": "Omalizumab",
    "rxcui": null,
    "category": "Asthma Biologic",
    "condition": "asthma-copd",
    "manufacturer": "Genentech / Novartis",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.genentech-access.com/patient.html",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.xolair.com/allergic-asthma/financial-support.html",
    "copayProgramId": "xolair-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "tezepelumab",
    "brandName": "Tezspire",
    "genericName": "Tezepelumab",
    "rxcui": null,
    "category": "Asthma Biologic",
    "condition": "asthma-copd",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": "astrazeneca-pap",
    "copayUrl": "https://copay.tezspiretogether.com/",
    "copayProgramId": "tezspire-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "dupilumab",
    "brandName": "Dupixent",
    "genericName": "Dupilumab",
    "rxcui": null,
    "category": "Asthma Biologic",
    "condition": "asthma-copd",
    "manufacturer": "Regeneron / Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.dupixent.com/support-savings/dupixent-my-way",
    "papProgramId": "sanofi-dupixent-pap",
    "copayUrl": "https://www.dupixent.com/support-savings/dupixent-my-way",
    "copayProgramId": "dupixent-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "nadolol",
    "brandName": "Corgard",
    "genericName": "Nadolol",
    "rxcui": "7226",
    "category": "Beta Blocker",
    "condition": "liver-disease",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "amlodipine",
    "brandName": "Norvasc",
    "genericName": "Amlodipine",
    "rxcui": "17767",
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "atenolol",
    "brandName": "Tenormin",
    "genericName": "Atenolol",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "bisoprolol",
    "brandName": "Zebeta",
    "genericName": "Bisoprolol",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "diltiazem",
    "brandName": "Cardizem",
    "genericName": "Diltiazem",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "enalapril",
    "brandName": "Vasotec",
    "genericName": "Enalapril",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "irbesartan",
    "brandName": "Avapro",
    "genericName": "Irbesartan",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lisinopril",
    "brandName": "Prinivil / Zestril",
    "genericName": "Lisinopril",
    "rxcui": "29046",
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "losartan",
    "brandName": "Cozaar",
    "genericName": "Losartan",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "nifedipine",
    "brandName": "Procardia / Adalat",
    "genericName": "Nifedipine",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "olmesartan",
    "brandName": "Benicar",
    "genericName": "Olmesartan",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "ramipril",
    "brandName": "Altace",
    "genericName": "Ramipril",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "valsartan",
    "brandName": "Diovan",
    "genericName": "Valsartan",
    "rxcui": null,
    "category": "Blood Pressure",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "neupogen",
    "brandName": "Neupogen",
    "genericName": "Filgrastim",
    "rxcui": "227304",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Amgen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.amgensupportplus.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "nivestym",
    "brandName": "Nivestym",
    "genericName": "Filgrastim-aafi",
    "rxcui": "2057201",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Pfizer",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "releuko",
    "brandName": "Releuko",
    "genericName": "Filgrastim-ayow",
    "rxcui": "2595946",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Amneal",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "zarxio",
    "brandName": "Zarxio",
    "genericName": "Filgrastim-sndz",
    "rxcui": "1605067",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Sandoz",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "nypozi",
    "brandName": "Nypozi",
    "genericName": "Filgrastim-txid",
    "rxcui": "2700371",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Sandoz",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "granix",
    "brandName": "Granix",
    "genericName": "Tbo-filgrastim",
    "rxcui": "1442677",
    "category": "Blood Support",
    "condition": "low-white-cells",
    "manufacturer": "Teva",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ipratropium-albuterol",
    "brandName": "Combivent / DuoNeb",
    "genericName": "Ipratropium/Albuterol",
    "rxcui": null,
    "category": "Bronchodilator",
    "condition": "asthma-copd",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.boehringer-ingelheim.com/us/patient-assistance",
    "papProgramId": "boehringer-ingelheim-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "umeclidinium-vilanterol",
    "brandName": "Anoro Ellipta",
    "genericName": "Umeclidinium/Vilanterol",
    "rxcui": null,
    "category": "Bronchodilator",
    "condition": "asthma-copd",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": "https://gskforyou.com/programs/gsk-coupons-free-trials/",
    "copayProgramId": "anoro-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "atorvastatin",
    "brandName": "Lipitor",
    "genericName": "Atorvastatin",
    "rxcui": "83367",
    "category": "Cholesterol",
    "condition": "high-cholesterol",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lovastatin",
    "brandName": "Mevacor",
    "genericName": "Lovastatin",
    "rxcui": null,
    "category": "Cholesterol",
    "condition": "high-cholesterol",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "pravastatin",
    "brandName": "Pravachol",
    "genericName": "Pravastatin",
    "rxcui": "42463",
    "category": "Cholesterol",
    "condition": "high-cholesterol",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "rosuvastatin",
    "brandName": "Crestor",
    "genericName": "Rosuvastatin",
    "rxcui": null,
    "category": "Cholesterol",
    "condition": "high-cholesterol",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "simvastatin",
    "brandName": "Zocor",
    "genericName": "Simvastatin",
    "rxcui": null,
    "category": "Cholesterol",
    "condition": "high-cholesterol",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "trikafta",
    "brandName": "Trikafta",
    "genericName": "Elexacaftor/Tezacaftor/Ivacaftor",
    "rxcui": null,
    "category": "Cystic Fibrosis",
    "condition": "cystic-fibrosis",
    "manufacturer": "Vertex",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.vertexgps.com/",
    "papProgramId": "vertex-pap",
    "copayUrl": "https://www.vertexgps.com/",
    "copayProgramId": "vertex-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "kalydeco",
    "brandName": "Kalydeco",
    "genericName": "Ivacaftor",
    "rxcui": "1243041",
    "category": "Cystic Fibrosis",
    "condition": "cystic-fibrosis",
    "manufacturer": "Vertex",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.vertexgps.com/",
    "papProgramId": "vertex-pap",
    "copayUrl": "https://www.vertexgps.com/",
    "copayProgramId": "vertex-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "orkambi",
    "brandName": "Orkambi",
    "genericName": "Lumacaftor/Ivacaftor",
    "rxcui": null,
    "category": "Cystic Fibrosis",
    "condition": "cystic-fibrosis",
    "manufacturer": "Vertex",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.vertexgps.com/",
    "papProgramId": "vertex-pap",
    "copayUrl": "https://www.vertexgps.com/",
    "copayProgramId": "vertex-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "symdeko",
    "brandName": "Symdeko",
    "genericName": "Tezacaftor/Ivacaftor",
    "rxcui": null,
    "category": "Cystic Fibrosis",
    "condition": "cystic-fibrosis",
    "manufacturer": "Vertex",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.vertexgps.com/",
    "papProgramId": "vertex-pap",
    "copayUrl": "https://www.vertexgps.com/",
    "copayProgramId": "vertex-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "nesina",
    "brandName": "Nesina",
    "genericName": "Alogliptin",
    "rxcui": "1368007",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Takeda",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.takeda.com/en-us/what-we-do/patient-services/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "brenzavvy",
    "brandName": "Brenzavvy",
    "genericName": "Bexagliflozin",
    "rxcui": "2637860",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "TheracosBio",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": false,
    "typical_copay_tier": "1"
  },
  {
    "id": "invokana",
    "brandName": "Invokana",
    "genericName": "Canagliflozin",
    "rxcui": "1373464",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Janssen",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "janssen-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "freestyle-libre",
    "brandName": "FreeStyle Libre",
    "genericName": "Continuous Glucose Monitor",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Abbott",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "guardian-connect",
    "brandName": "Medtronic Guardian Connect",
    "genericName": "Continuous Glucose Monitor",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Medtronic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "eversense",
    "brandName": "Eversense",
    "genericName": "Continuous Glucose Monitor",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Ascensia",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "dexcom",
    "brandName": "Dexcom",
    "genericName": "Continuous Glucose Monitor",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Dexcom",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "farxiga",
    "brandName": "Farxiga",
    "genericName": "Dapagliflozin",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": "astrazeneca-pap",
    "copayUrl": "https://www.farxiga.com/savings-support",
    "copayProgramId": "farxiga-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "dulaglutide",
    "brandName": "Trulicity",
    "genericName": "Dulaglutide",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": "lilly-pap",
    "copayUrl": "https://www.trulicity.com/savings-and-resources",
    "copayProgramId": "trulicity-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "jardiance",
    "brandName": "Jardiance",
    "genericName": "Empagliflozin",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.boehringer-ingelheim.com/us/patient-assistance",
    "papProgramId": "boehringer-ingelheim-pap",
    "copayUrl": "https://www.jardiance.com/savings/",
    "copayProgramId": "jardiance-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "glimepiride",
    "brandName": "Amaryl",
    "genericName": "Glimepiride",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "glipizide",
    "brandName": "Glucotrol",
    "genericName": "Glipizide",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "baqsimi",
    "brandName": "Baqsimi",
    "genericName": "Glucagon (Nasal)",
    "rxcui": "2180667",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Amphastar",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "glyburide",
    "brandName": "DiaBeta / Glynase",
    "genericName": "Glyburide",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "insulin-aspart",
    "brandName": "Novolog",
    "genericName": "Insulin Aspart",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": "novo-nordisk-pap",
    "copayUrl": "https://www.novolog.com/savings.html",
    "copayProgramId": "novolog-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "fiasp",
    "brandName": "Fiasp",
    "genericName": "Insulin Aspart",
    "rxcui": "1986350",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "novolog-mix-70-30",
    "brandName": "NovoLog Mix 70/30",
    "genericName": "Insulin Aspart Protamine/Insulin Aspart",
    "rxcui": "1372741",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "tresiba",
    "brandName": "Tresiba",
    "genericName": "Insulin Degludec",
    "rxcui": "1670012",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "insulin-glargine",
    "brandName": "Lantus / Basaglar",
    "genericName": "Insulin Glargine",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Sanofi / Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": "sanofi-pap",
    "copayUrl": "https://www.lantus.com/sign-up-for-savings",
    "copayProgramId": "lantus-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "toujeo",
    "brandName": "Toujeo",
    "genericName": "Insulin Glargine U-300",
    "rxcui": "1604540",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "rezvoglar",
    "brandName": "Rezvoglar",
    "genericName": "Insulin Glargine-aglr",
    "rxcui": "2589010",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": false,
    "typical_copay_tier": "3"
  },
  {
    "id": "semglee",
    "brandName": "Semglee",
    "genericName": "Insulin Glargine-yfgn",
    "rxcui": "2377130",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Biocon Biologics",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": false,
    "typical_copay_tier": "3"
  },
  {
    "id": "soliqua",
    "brandName": "Soliqua 100/33",
    "genericName": "Insulin Glargine/Lixisenatide",
    "rxcui": "1858996",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "apidra",
    "brandName": "Apidra",
    "genericName": "Insulin Glulisine",
    "rxcui": "607583",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "afrezza",
    "brandName": "Afrezza",
    "genericName": "Insulin Human (Inhalation)",
    "rxcui": "1543203",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "MannKind",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "insulin-lispro",
    "brandName": "Humalog",
    "genericName": "Insulin Lispro",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": "lilly-pap",
    "copayUrl": "https://www.humalog.com/savings-support",
    "copayProgramId": "humalog-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "admelog",
    "brandName": "Admelog",
    "genericName": "Insulin Lispro",
    "rxcui": "1992165",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "humalog-mix",
    "brandName": "Humalog Mix",
    "genericName": "Insulin Lispro Protamine/Insulin Lispro",
    "rxcui": "752388",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "humulin-n",
    "brandName": "Humulin N",
    "genericName": "Insulin NPH",
    "rxcui": "92880",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "humulin-70-30",
    "brandName": "Humulin 70/30",
    "genericName": "Insulin NPH/Regular",
    "rxcui": "1372744",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "humulin-r",
    "brandName": "Humulin R",
    "genericName": "Insulin Regular",
    "rxcui": "92881",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.lillycares.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "tradjenta",
    "brandName": "Tradjenta",
    "genericName": "Linagliptin",
    "rxcui": "1100703",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.boehringer-ingelheim.com/us/patient-assistance",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "saxenda",
    "brandName": "Saxenda",
    "genericName": "Liraglutide",
    "rxcui": "1598264",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "victoza",
    "brandName": "Victoza",
    "genericName": "Liraglutide",
    "rxcui": "897123",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "metformin",
    "brandName": "Glucophage",
    "genericName": "Metformin",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "pioglitazone",
    "brandName": "Actos",
    "genericName": "Pioglitazone",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Takeda",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.takeda.com/en-us/what-we-do/patient-services/",
    "papProgramId": "takeda-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "resmetirom",
    "brandName": "Rezdiffra",
    "genericName": "Resmetirom",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Madrigal",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://madrigalpatientsupport.com/",
    "papProgramId": "madrigal-pap",
    "copayUrl": "https://madrigalpatientsupport.com/",
    "copayProgramId": "rezdiffra-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "semaglutide",
    "brandName": "Ozempic / Wegovy",
    "genericName": "Semaglutide",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": "novo-nordisk-pap",
    "copayUrl": "https://www.ozempic.com/savings-and-resources/save-on-ozempic.html",
    "copayProgramId": "ozempic-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "rybelsus",
    "brandName": "Rybelsus",
    "genericName": "Semaglutide (Oral)",
    "rxcui": "2200645",
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Novo Nordisk",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.novocare.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "sitagliptin",
    "brandName": "Januvia",
    "genericName": "Sitagliptin",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Merck",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": "https://www.merckhelps.com/",
    "papProgramId": "merck-pap",
    "copayUrl": "https://www.januvia.com/savings-and-resources/",
    "copayProgramId": "januvia-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "vitamin-e",
    "brandName": "Aqua Gem-E / d-Alpha-Tocopherol",
    "genericName": "Vitamin E",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "0455fed9-a5d3-4aec-bb95-5200d077c92e",
    "brandName": "Mounjaro / Zepbound",
    "genericName": "tirzepatide",
    "rxcui": null,
    "category": "Diabetes",
    "condition": "diabetes",
    "manufacturer": "Lilly",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": null,
    "generic_available": false,
    "typical_copay_tier": null
  },
  {
    "id": "bumetanide",
    "brandName": "Bumex",
    "genericName": "Bumetanide",
    "rxcui": "1808",
    "category": "Diuretic",
    "condition": "fluid-retention",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "chlorthalidone",
    "brandName": "Thalitone",
    "genericName": "Chlorthalidone",
    "rxcui": null,
    "category": "Diuretic",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "eplerenone",
    "brandName": "Inspra",
    "genericName": "Eplerenone",
    "rxcui": "298869",
    "category": "Diuretic",
    "condition": "fluid-retention",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lasix",
    "brandName": "Lasix",
    "genericName": "Furosemide",
    "rxcui": "4603",
    "category": "Diuretic",
    "condition": "fluid-retention",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "hydrochlorothiazide",
    "brandName": "Microzide",
    "genericName": "Hydrochlorothiazide",
    "rxcui": null,
    "category": "Diuretic",
    "condition": "high-blood-pressure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "aldactone",
    "brandName": "Aldactone",
    "genericName": "Spironolactone",
    "rxcui": null,
    "category": "Diuretic",
    "condition": "fluid-retention",
    "manufacturer": "Pfizer",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "potassium-chloride",
    "brandName": "Klor-Con",
    "genericName": "Potassium Chloride",
    "rxcui": null,
    "category": "Electrolyte",
    "condition": "electrolytes",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "creon",
    "brandName": "Creon / Zenpep",
    "genericName": "Pancrelipase",
    "rxcui": null,
    "category": "Enzymes",
    "condition": "pancreatic-insufficiency",
    "manufacturer": "AbbVie / Nestle",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.creoninfo.com/",
    "papProgramId": "abbvie-creon-pap",
    "copayUrl": "https://www.creoninfo.com/cost-savings",
    "copayProgramId": "creon-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "esomeprazole",
    "brandName": "Nexium",
    "genericName": "Esomeprazole",
    "rxcui": null,
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "famotidine",
    "brandName": "Pepcid",
    "genericName": "Famotidine",
    "rxcui": null,
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lansoprazole",
    "brandName": "Prevacid",
    "genericName": "Lansoprazole",
    "rxcui": null,
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "omeprazole",
    "brandName": "Prilosec",
    "genericName": "Omeprazole",
    "rxcui": "7646",
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "protonix",
    "brandName": "Protonix",
    "genericName": "Pantoprazole",
    "rxcui": "40790",
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "ranitidine",
    "brandName": "Zantac",
    "genericName": "Ranitidine",
    "rxcui": null,
    "category": "GI / Acid Suppression",
    "condition": "acid-reflux",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "dicyclomine",
    "brandName": "Bentyl",
    "genericName": "Dicyclomine",
    "rxcui": null,
    "category": "GI Support",
    "condition": "digestive",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "loperamide",
    "brandName": "Imodium",
    "genericName": "Loperamide",
    "rxcui": null,
    "category": "GI Support",
    "condition": "digestive",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "miralax",
    "brandName": "Miralax",
    "genericName": "Polyethylene Glycol",
    "rxcui": null,
    "category": "GI Support",
    "condition": "digestive",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "allopurinol",
    "brandName": "Zyloprim",
    "genericName": "Allopurinol",
    "rxcui": null,
    "category": "Gout",
    "condition": "gout",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "colchicine",
    "brandName": "Colcrys",
    "genericName": "Colchicine",
    "rxcui": null,
    "category": "Gout",
    "condition": "gout",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "coreg",
    "brandName": "Coreg",
    "genericName": "Carvedilol",
    "rxcui": "20352",
    "category": "Heart Failure",
    "condition": "heart-failure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "digoxin",
    "brandName": "Lanoxin",
    "genericName": "Digoxin",
    "rxcui": null,
    "category": "Heart Failure",
    "condition": "heart-failure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lopressor",
    "brandName": "Lopressor / Toprol XL",
    "genericName": "Metoprolol",
    "rxcui": "6918",
    "category": "Heart Failure",
    "condition": "heart-failure",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "entresto",
    "brandName": "Entresto",
    "genericName": "Sacubitril/Valsartan",
    "rxcui": null,
    "category": "Heart Failure",
    "condition": "heart-failure",
    "manufacturer": "Novartis",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart"
    ],
    "papUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "papProgramId": "novartis-pap",
    "copayUrl": "https://www.entresto.com/financial-support",
    "copayProgramId": "entresto-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "baraclude",
    "brandName": "Baraclude",
    "genericName": "Entecavir",
    "rxcui": "404879",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Bristol Myers Squibb",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.bmspaf.org/",
    "papProgramId": "bms-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "mavyret",
    "brandName": "Mavyret",
    "genericName": "Glecaprevir/Pibrentasvir",
    "rxcui": "1939261",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "AbbVie",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.abbvie.com/patients/patient-assistance.html",
    "papProgramId": "abbvie-pap",
    "copayUrl": "https://www.mavyret.com/cost",
    "copayProgramId": "mavyret-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "hbig",
    "brandName": "HepaGam B / HyperHEP B",
    "genericName": "Hepatitis B Immune Globulin",
    "rxcui": null,
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Saol / Grifols",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.hepagamb.com/",
    "papProgramId": "grifols-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "harvoni",
    "brandName": "Harvoni",
    "genericName": "Ledipasvir/Sofosbuvir",
    "rxcui": "1591944",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "epclusa",
    "brandName": "Epclusa",
    "genericName": "Sofosbuvir/Velpatasvir",
    "rxcui": "1716964",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": "gilead-pap",
    "copayUrl": "https://www.gileadadvancingaccess.com/",
    "copayProgramId": "epclusa-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "vosevi",
    "brandName": "Vosevi",
    "genericName": "Sofosbuvir/Velpatasvir/Voxilaprevir",
    "rxcui": "1939330",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "vemlidy",
    "brandName": "Vemlidy",
    "genericName": "Tenofovir Alafenamide",
    "rxcui": null,
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": "gilead-pap",
    "copayUrl": "https://www.gileadadvancingaccess.com/",
    "copayProgramId": "vemlidy-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "viread",
    "brandName": "Viread",
    "genericName": "Tenofovir Disoproxil",
    "rxcui": "318473",
    "category": "Hepatitis B/C",
    "condition": "hepatitis",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": "gilead-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "imuran",
    "brandName": "Imuran",
    "genericName": "Azathioprine",
    "rxcui": "1256",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "belatacept",
    "brandName": "Nulojix",
    "genericName": "Belatacept",
    "rxcui": "1091444",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Bristol Myers Squibb",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.bmspaf.org/",
    "papProgramId": "bms-pap",
    "copayUrl": "https://www.bmscopay.com/",
    "copayProgramId": "nulojix-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "cyclosporine",
    "brandName": "Neoral / Sandimmune / Gengraf",
    "genericName": "Cyclosporine",
    "rxcui": "3008",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Novartis",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "papProgramId": "novartis-pap",
    "copayUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "copayProgramId": "novartis-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "everolimus",
    "brandName": "Everolimus (generic)",
    "genericName": "Everolimus",
    "rxcui": "141704",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "zortress",
    "brandName": "Zortress",
    "genericName": "Everolimus",
    "rxcui": null,
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Novartis",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "papProgramId": "novartis-pap",
    "copayUrl": "https://www.zortress.com/transplant/savings-and-support",
    "copayProgramId": "zortress-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "mycophenolate",
    "brandName": "Mycophenolate Mofetil (generic)",
    "genericName": "Mycophenolate Mofetil",
    "rxcui": "68149",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cellcept",
    "brandName": "CellCept",
    "genericName": "Mycophenolate Mofetil",
    "rxcui": null,
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Genentech",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.genentech-access.com/patient.html",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.genentech-access.com/patient.html",
    "copayProgramId": "genentech-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "myfortic",
    "brandName": "Myfortic",
    "genericName": "Mycophenolic Acid",
    "rxcui": "327361",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Novartis",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "papProgramId": "novartis-pap",
    "copayUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "copayProgramId": "novartis-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "sirolimus",
    "brandName": "Rapamune",
    "genericName": "Sirolimus",
    "rxcui": "35302",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Pfizer",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "pfizer-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "tacrolimus",
    "brandName": "Tacrolimus (generic)",
    "genericName": "Tacrolimus",
    "rxcui": "42316",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "prograf",
    "brandName": "Prograf",
    "genericName": "Tacrolimus",
    "rxcui": "196463",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Astellas",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.astellaspharmasupportsolutions.com/",
    "papProgramId": "astellas-pap",
    "copayUrl": "https://astellascares.com/",
    "copayProgramId": "astellas-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "envarsus-xr",
    "brandName": "Envarsus XR",
    "genericName": "Tacrolimus Extended-Release",
    "rxcui": "1664435",
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Veloxis",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://veloxistransplantsupport.com/",
    "papProgramId": "veloxis-pap",
    "copayUrl": "https://www.envarsusxr.com/savings-support",
    "copayProgramId": "envarsus-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "astagraf-xl",
    "brandName": "Astagraf XL",
    "genericName": "Tacrolimus Extended-Release",
    "rxcui": null,
    "category": "Immunosuppressant",
    "condition": "rejection-prevention",
    "manufacturer": "Astellas",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.astellaspharmasupportsolutions.com/",
    "papProgramId": "astellas-pap",
    "copayUrl": "https://astellascares.com/",
    "copayProgramId": "astellas-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "campath",
    "brandName": "Campath",
    "genericName": "Alemtuzumab",
    "rxcui": null,
    "category": "Induction",
    "condition": "rejection-prevention",
    "manufacturer": "Sanofi",
    "stage": "Peri-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": "sanofi-pap",
    "copayUrl": "https://www.sanofipatientconnection.com/",
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "atgam",
    "brandName": "ATGAM",
    "genericName": "Anti-thymocyte globulin (Equine)",
    "rxcui": "1011",
    "category": "Induction",
    "condition": "rejection-prevention",
    "manufacturer": "Pfizer",
    "stage": "Peri-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "pfizer-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "thymoglobulin",
    "brandName": "Thymoglobulin",
    "genericName": "Anti-thymocyte globulin (Rabbit)",
    "rxcui": "89125",
    "category": "Induction",
    "condition": "rejection-prevention",
    "manufacturer": "Sanofi",
    "stage": "Peri-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": "sanofi-pap",
    "copayUrl": "https://www.thymoglobulin.com/resources",
    "copayProgramId": "thymoglobulin-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "simulect",
    "brandName": "Simulect",
    "genericName": "Basiliximab",
    "rxcui": "114169",
    "category": "Induction",
    "condition": "rejection-prevention",
    "manufacturer": "Novartis",
    "stage": "Peri-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "papProgramId": "novartis-pap",
    "copayUrl": "https://www.novartis.com/us-en/patients-and-caregivers/patient-assistance",
    "copayProgramId": "simulect-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "rituxan",
    "brandName": "Rituxan",
    "genericName": "Rituximab",
    "rxcui": null,
    "category": "Induction",
    "condition": "rejection-prevention",
    "manufacturer": "Genentech",
    "stage": "Peri-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.genentech-access.com/patient.html",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.genentech-access.com/patient.html",
    "copayProgramId": "genentech-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "mepron",
    "brandName": "Mepron",
    "genericName": "Atovaquone",
    "rxcui": "114972",
    "category": "Infection Prevention",
    "condition": "infection",
    "manufacturer": "GSK",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "bactrim",
    "brandName": "Bactrim / Septra",
    "genericName": "Trimethoprim-Sulfamethoxazole",
    "rxcui": "10831",
    "category": "Infection Prevention",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cayston",
    "brandName": "Cayston",
    "genericName": "Aztreonam Inhaled",
    "rxcui": "742627",
    "category": "Inhaled Antibiotic",
    "condition": "infection",
    "manufacturer": "Gilead",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": "gilead-pap",
    "copayUrl": "https://www.gileadadvancingaccess.com/",
    "copayProgramId": "gilead-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "tobramycin-inhaled",
    "brandName": "TOBI / Bethkis / Kitabis Pak",
    "genericName": "Tobramycin Inhaled",
    "rxcui": "1248038",
    "category": "Inhaled Antibiotic",
    "condition": "infection",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "beclomethasone",
    "brandName": "QVAR",
    "genericName": "Beclomethasone",
    "rxcui": null,
    "category": "Inhaled Corticosteroid",
    "condition": "asthma-copd",
    "manufacturer": "Teva",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.qvar.com/redihaler/teva-patient-assistance-program",
    "papProgramId": "teva-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "ciclesonide",
    "brandName": "Alvesco",
    "genericName": "Ciclesonide",
    "rxcui": null,
    "category": "Inhaled Corticosteroid",
    "condition": "asthma-copd",
    "manufacturer": "Sunovion",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.sunovion.com/patient-support",
    "papProgramId": "sunovion-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "calcitriol",
    "brandName": "Rocaltrol / Calcijex",
    "genericName": "Calcitriol",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Generic",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "phoslo",
    "brandName": "PhosLo",
    "genericName": "Calcium Acetate",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Generic",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "sensipar",
    "brandName": "Sensipar",
    "genericName": "Cinacalcet",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Amgen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.amgensupportplus.com/",
    "papProgramId": "amgen-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "hectorol",
    "brandName": "Hectorol",
    "genericName": "Doxercalciferol",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Sanofi",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": "sanofi-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": false,
    "typical_copay_tier": "3"
  },
  {
    "id": "parsabiv",
    "brandName": "Parsabiv",
    "genericName": "Etelcalcetide",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Amgen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.amgensupportplus.com/",
    "papProgramId": "amgen-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "auryxia",
    "brandName": "Auryxia",
    "genericName": "Ferric Citrate",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Akebia",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.akebiacares.com/",
    "papProgramId": "akebia-auryxia-pap",
    "copayUrl": "https://www.akebiacares.com/",
    "copayProgramId": "auryxia-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "zemplar",
    "brandName": "Zemplar",
    "genericName": "Paricalcitol",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "AbbVie",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.abbvie.com/patients/patient-assistance.html",
    "papProgramId": "abbvie-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": false,
    "typical_copay_tier": "3"
  },
  {
    "id": "veltassa",
    "brandName": "Veltassa",
    "genericName": "Patiromer",
    "rxcui": "1716210",
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Sanofi",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "renvela",
    "brandName": "Renvela",
    "genericName": "Sevelamer",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Sanofi",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.sanofipatientconnection.com/",
    "papProgramId": "sanofi-pap",
    "copayUrl": "https://www.sanofipatientconnection.com/",
    "copayProgramId": "sanofi-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "lokelma",
    "brandName": "Lokelma",
    "genericName": "Sodium Zirconium Cyclosilicate",
    "rxcui": "2047634",
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "zafirlukast",
    "brandName": "Accolate",
    "genericName": "Zafirlukast",
    "rxcui": null,
    "category": "Leukotriene Modifier",
    "condition": "asthma-copd",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "zileuton",
    "brandName": "Zyflo",
    "genericName": "Zileuton",
    "rxcui": null,
    "category": "Leukotriene Modifier",
    "condition": "asthma-copd",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "lactulose",
    "brandName": "Kristalose / Generlac",
    "genericName": "Lactulose",
    "rxcui": null,
    "category": "Liver Support",
    "condition": "liver-disease",
    "manufacturer": "Generic",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "inderal",
    "brandName": "Inderal",
    "genericName": "Propranolol",
    "rxcui": null,
    "category": "Liver Support",
    "condition": "liver-disease",
    "manufacturer": "Generic",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "rifaximin",
    "brandName": "Xifaxan",
    "genericName": "Rifaximin",
    "rxcui": "35619",
    "category": "Liver Support",
    "condition": "liver-disease",
    "manufacturer": "Salix (Bausch Health)",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": "https://www.bauschhealthpap.com/",
    "papProgramId": "bausch-pap",
    "copayUrl": "https://www.xifaxan.com/",
    "copayProgramId": "salix-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ursodiol",
    "brandName": "Urso / Actigall",
    "genericName": "Ursodiol",
    "rxcui": "10904",
    "category": "Liver Support",
    "condition": "liver-disease",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "7b75e9cc-d355-43de-91a3-f7330c9409fd",
    "brandName": "ProAmatine",
    "genericName": "midodrine",
    "rxcui": null,
    "category": "Liver Support",
    "condition": "liver-disease",
    "manufacturer": null,
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": null,
    "generic_available": true,
    "typical_copay_tier": null
  },
  {
    "id": "cromolyn",
    "brandName": "NasalCrom",
    "genericName": "Cromolyn Sodium",
    "rxcui": null,
    "category": "Mast Cell Stabilizer",
    "condition": "asthma-copd",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "alprazolam",
    "brandName": "Xanax",
    "genericName": "Alprazolam",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "bupropion",
    "brandName": "Wellbutrin / Zyban",
    "genericName": "Bupropion",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "buspirone",
    "brandName": "BuSpar",
    "genericName": "Buspirone",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "citalopram",
    "brandName": "Celexa",
    "genericName": "Citalopram",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "clonazepam",
    "brandName": "Klonopin",
    "genericName": "Clonazepam",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "duloxetine",
    "brandName": "Cymbalta",
    "genericName": "Duloxetine",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "escitalopram",
    "brandName": "Lexapro",
    "genericName": "Escitalopram",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "fluoxetine",
    "brandName": "Prozac",
    "genericName": "Fluoxetine",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "gabapentin",
    "brandName": "Neurontin",
    "genericName": "Gabapentin",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "lorazepam",
    "brandName": "Ativan",
    "genericName": "Lorazepam",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "pregabalin",
    "brandName": "Lyrica",
    "genericName": "Pregabalin",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Pfizer",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "lyrica-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "sertraline",
    "brandName": "Zoloft",
    "genericName": "Sertraline",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "trazodone",
    "brandName": "Desyrel",
    "genericName": "Trazodone",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "venlafaxine",
    "brandName": "Effexor",
    "genericName": "Venlafaxine",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "zolpidem",
    "brandName": "Ambien",
    "genericName": "Zolpidem",
    "rxcui": null,
    "category": "Mental Health",
    "condition": "mental-health",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "pulmozyme",
    "brandName": "Pulmozyme",
    "genericName": "Dornase Alfa",
    "rxcui": "3414",
    "category": "Mucolytic",
    "condition": "cystic-fibrosis",
    "manufacturer": "Genentech",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.genentech-access.com/",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.pulmozyme.com/",
    "copayProgramId": "genentech-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ibuprofen",
    "brandName": "Motrin / Advil",
    "genericName": "Ibuprofen",
    "rxcui": null,
    "category": "NSAID",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "meloxicam",
    "brandName": "Mobic",
    "genericName": "Meloxicam",
    "rxcui": null,
    "category": "NSAID",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "naproxen",
    "brandName": "Naprosyn / Aleve",
    "genericName": "Naproxen",
    "rxcui": null,
    "category": "NSAID",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "azelastine-nasal",
    "brandName": "Astelin / Astepro",
    "genericName": "Azelastine Nasal",
    "rxcui": null,
    "category": "Nasal Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "olopatadine-nasal",
    "brandName": "Patanase",
    "genericName": "Olopatadine Nasal",
    "rxcui": null,
    "category": "Nasal Antihistamine",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "fluticasone-nasal",
    "brandName": "Flonase",
    "genericName": "Fluticasone Nasal",
    "rxcui": null,
    "category": "Nasal Corticosteroid",
    "condition": "allergies",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "mometasone-nasal",
    "brandName": "Nasonex",
    "genericName": "Mometasone Nasal",
    "rxcui": null,
    "category": "Nasal Corticosteroid",
    "condition": "allergies",
    "manufacturer": "Organon",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.organonhelps.com/",
    "papProgramId": "organon-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "triamcinolone-nasal",
    "brandName": "Nasacort",
    "genericName": "Triamcinolone Nasal",
    "rxcui": null,
    "category": "Nasal Corticosteroid",
    "condition": "allergies",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "tramadol",
    "brandName": "Ultram",
    "genericName": "Tramadol",
    "rxcui": null,
    "category": "Pain Management",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "hydrocodone-acetaminophen",
    "brandName": "Norco / Vicodin",
    "genericName": "Hydrocodone/Acetaminophen",
    "rxcui": null,
    "category": "Pain Management",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "oxycodone",
    "brandName": "OxyContin / Roxicodone",
    "genericName": "Oxycodone",
    "rxcui": null,
    "category": "Pain Management",
    "condition": "pain",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "sevelamer",
    "brandName": "Sevelamer (generic)",
    "genericName": "Sevelamer",
    "rxcui": null,
    "category": "Kidney Support",
    "condition": "kidney-disease",
    "manufacturer": "Generic",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Kidney"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ofev",
    "brandName": "Ofev",
    "genericName": "Nintedanib",
    "rxcui": "1599538",
    "category": "Pulmonary Fibrosis",
    "condition": "pulmonary-fibrosis",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.bicares.com/",
    "papProgramId": "boehringer-pap",
    "copayUrl": "https://www.ofev.com/financial-support",
    "copayProgramId": "boehringer-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "esbriet",
    "brandName": "Esbriet",
    "genericName": "Pirfenidone",
    "rxcui": "1373424",
    "category": "Pulmonary Fibrosis",
    "condition": "pulmonary-fibrosis",
    "manufacturer": "Genentech",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.genentech-access.com/",
    "papProgramId": "genentech-pap",
    "copayUrl": "https://www.esbrietcopay.com/",
    "copayProgramId": "genentech-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "letairis",
    "brandName": "Letairis",
    "genericName": "Ambrisentan",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Gilead",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.gileadadvancingaccess.com/",
    "papProgramId": "gilead-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "tracleer",
    "brandName": "Tracleer",
    "genericName": "Bosentan",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "flolan",
    "brandName": "Flolan",
    "genericName": "Epoprostenol",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "veletri",
    "brandName": "Veletri",
    "genericName": "Epoprostenol",
    "rxcui": "8814",
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.jnjwithme.com/",
    "copayProgramId": "janssen-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "ventavis",
    "brandName": "Ventavis",
    "genericName": "Iloprost",
    "rxcui": "54409",
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.jnjwithme.com/",
    "copayProgramId": "janssen-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "opsumit",
    "brandName": "Opsumit",
    "genericName": "Macitentan",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.opsumit.com/support",
    "copayProgramId": "opsumit-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "opsynvi",
    "brandName": "Opsynvi",
    "genericName": "Macitentan/Tadalafil",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.jnjwithme.com/",
    "copayProgramId": "janssen-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "adempas",
    "brandName": "Adempas",
    "genericName": "Riociguat",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Bayer",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.adempas-us.com/",
    "papProgramId": "bayer-adempas-pap",
    "copayUrl": "https://www.adempas-us.com/cteph/financial-support",
    "copayProgramId": "adempas-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "uptravi",
    "brandName": "Uptravi",
    "genericName": "Selexipag",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Actelion/Janssen",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.jnjwithme.com/",
    "papProgramId": "janssen-pap",
    "copayUrl": "https://www.uptravi.com/resources-and-cost-support/support-programs/",
    "copayProgramId": "uptravi-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "revatio",
    "brandName": "Revatio / Viagra",
    "genericName": "Sildenafil",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Pfizer",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": "https://www.pfizerrxpathways.com/",
    "copayProgramId": "pfizer-copay",
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "winrevair",
    "brandName": "Winrevair",
    "genericName": "Sotatercept",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "Merck",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://www.merckhelps.com/",
    "papProgramId": "merck-pap",
    "copayUrl": "https://www.merckaccessprogram-winrevair.com/",
    "copayProgramId": "merck-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "adcirca",
    "brandName": "Adcirca",
    "genericName": "Tadalafil",
    "rxcui": "358263",
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "United Therapeutics",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://unitedtherapeuticscares.com/",
    "papProgramId": "united-therapeutics-pap",
    "copayUrl": "https://unitedtherapeuticscares.com/",
    "copayProgramId": "united-therapeutics-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": true,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "remodulin",
    "brandName": "Remodulin",
    "genericName": "Treprostinil",
    "rxcui": null,
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "United Therapeutics",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://unitedtherapeuticscares.com/",
    "papProgramId": "united-therapeutics-pap",
    "copayUrl": "https://unitedtherapeuticscares.com/",
    "copayProgramId": "tyvaso-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "tyvaso",
    "brandName": "Tyvaso",
    "genericName": "Treprostinil (Inhaled)",
    "rxcui": "38663",
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "United Therapeutics",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://unitedtherapeuticscares.com/",
    "papProgramId": "united-therapeutics-pap",
    "copayUrl": "https://unitedtherapeuticscares.com/",
    "copayProgramId": "united-therapeutics-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "orenitram",
    "brandName": "Orenitram",
    "genericName": "Treprostinil (Oral)",
    "rxcui": "38663",
    "category": "Pulmonary Hypertension",
    "condition": "pulmonary-hypertension",
    "manufacturer": "United Therapeutics",
    "stage": "Pre-transplant",
    "commonOrgans": [
      "Heart",
      "Lung"
    ],
    "papUrl": "https://unitedtherapeuticscares.com/",
    "papProgramId": "united-therapeutics-pap",
    "copayUrl": "https://unitedtherapeuticscares.com/",
    "copayProgramId": "united-therapeutics-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "Specialty"
  },
  {
    "id": "albuterol",
    "brandName": "ProAir / Ventolin / Proventil",
    "genericName": "Albuterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "budesonide-inhaled",
    "brandName": "Pulmicort",
    "genericName": "Budesonide",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": "astrazeneca-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "budesonide-formoterol",
    "brandName": "Symbicort",
    "genericName": "Budesonide/Formoterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "AstraZeneca",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.azandmeapp.com/",
    "papProgramId": "astrazeneca-pap",
    "copayUrl": "https://www.symbicort.com/savings-and-support",
    "copayProgramId": "symbicort-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "fluticasone",
    "brandName": "Flovent",
    "genericName": "Fluticasone",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "fluticasone-salmeterol",
    "brandName": "Advair",
    "genericName": "Fluticasone/Salmeterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": "https://gskforyou.com/programs/gsk-coupons-free-trials/",
    "copayProgramId": "advair-copay",
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "3"
  },
  {
    "id": "fluticasone-vilanterol",
    "brandName": "Breo Ellipta",
    "genericName": "Fluticasone/Vilanterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "GlaxoSmithKline",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.gskforyou.com/",
    "papProgramId": "gsk-pap",
    "copayUrl": "https://gskforyou.com/programs/gsk-coupons-free-trials/",
    "copayProgramId": "breo-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "ipratropium",
    "brandName": "Atrovent",
    "genericName": "Ipratropium",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.boehringer-ingelheim.com/us/patient-assistance",
    "papProgramId": "boehringer-ingelheim-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "levalbuterol",
    "brandName": "Xopenex",
    "genericName": "Levalbuterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Sunovion",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.sunovion.com/patient-support",
    "papProgramId": "sunovion-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "medium",
    "generic_available": true,
    "typical_copay_tier": "2"
  },
  {
    "id": "mometasone-inhaled",
    "brandName": "Asmanex",
    "genericName": "Mometasone",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Organon",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.organonhelps.com/",
    "papProgramId": "organon-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "mometasone-formoterol",
    "brandName": "Dulera",
    "genericName": "Mometasone/Formoterol",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Organon",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.organonhelps.com/",
    "papProgramId": "organon-pap",
    "copayUrl": "https://www.dulera.com/savings-offer/",
    "copayProgramId": "dulera-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "montelukast",
    "brandName": "Singulair",
    "genericName": "Montelukast",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "tiotropium",
    "brandName": "Spiriva",
    "genericName": "Tiotropium",
    "rxcui": null,
    "category": "Respiratory",
    "condition": "asthma-copd",
    "manufacturer": "Boehringer Ingelheim",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Lung"
    ],
    "papUrl": "https://www.boehringer-ingelheim.com/us/patient-assistance",
    "papProgramId": "boehringer-ingelheim-pap",
    "copayUrl": "https://www.spiriva.com/copd-resources/savings",
    "copayProgramId": "spiriva-copay",
    "supportUrl": null,
    "cost_tier": "high",
    "generic_available": false,
    "typical_copay_tier": "4"
  },
  {
    "id": "solumedrol",
    "brandName": "Solu-Medrol",
    "genericName": "Methylprednisolone",
    "rxcui": "6902",
    "category": "Steroid",
    "condition": "rejection-prevention",
    "manufacturer": "Pfizer",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Intestine",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": "https://www.pfizerrxpathways.com/",
    "papProgramId": "pfizer-pap",
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "prednisone",
    "brandName": "Prednisone",
    "genericName": "Prednisone",
    "rxcui": "8640",
    "category": "Steroid",
    "condition": "rejection-prevention",
    "manufacturer": "Generic",
    "stage": "Post-transplant",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "ferrous-sulfate",
    "brandName": "Feosol",
    "genericName": "Ferrous Sulfate",
    "rxcui": null,
    "category": "Supplement",
    "condition": "anemia",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "levothyroxine",
    "brandName": "Synthroid / Levoxyl",
    "genericName": "Levothyroxine",
    "rxcui": null,
    "category": "Thyroid",
    "condition": "thyroid",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "liothyronine",
    "brandName": "Cytomel",
    "genericName": "Liothyronine",
    "rxcui": null,
    "category": "Thyroid",
    "condition": "thyroid",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "cholecalciferol",
    "brandName": "Vitamin D3",
    "genericName": "Cholecalciferol",
    "rxcui": null,
    "category": "Vitamin",
    "condition": "nutrition",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "folic-acid",
    "brandName": "Folate",
    "genericName": "Folic Acid",
    "rxcui": null,
    "category": "Vitamin",
    "condition": "nutrition",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "multivitamin",
    "brandName": "Centrum",
    "genericName": "Multivitamin",
    "rxcui": null,
    "category": "Vitamin",
    "condition": "nutrition",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Lung",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  },
  {
    "id": "vitamin-d",
    "brandName": "Calciferol",
    "genericName": "Vitamin D",
    "rxcui": null,
    "category": "Vitamin",
    "condition": "nutrition",
    "manufacturer": "Generic",
    "stage": "Both (Pre & Post)",
    "commonOrgans": [
      "Heart",
      "Kidney",
      "Liver",
      "Pancreas"
    ],
    "papUrl": null,
    "papProgramId": null,
    "copayUrl": null,
    "copayProgramId": null,
    "supportUrl": null,
    "cost_tier": "low",
    "generic_available": true,
    "typical_copay_tier": "1"
  }
]
